import styled from "styled-components";
import { media } from '@/styles/Qtheme.ts';

export const CDrawerSection = styled.div<{ display?: string }>`
  top: 50px;
    position: absolute;
  left: 0;
  width: 420px;
  height: 60%;
  /* background-color: ${({theme}) => theme.itemBg}; */
  z-index: 19999 !important;

  transform: translateX(0);
  transition: transform 0.3s ease-out;

    //overflow-y: auto; /* Drawer 내부 스크롤 활성화 */
    @media ${media.mobile} {
        width: 95%;
        top: 50px;
        height: 100%;
         top: 50px;
    }
`;

export const DrawerHeaderSection = styled.div`
  display: flex;
  height: 50px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-inline: 15px;
    
`;
export const DrawerCloseIcon = styled.button`
	background-color: transparent;
	border: none;
	border-radius: 50px;
	padding: 5px;
	cursor: pointer;
	&:hover {
		background-color: ${props => props.theme.COLORS.gray};
	}
`
